/**
 * Converts any object (filter payload) into URLSearchParams.
 * Automatically skips null/undefined/empty values.
 * Allows optional key ordering.
 */
export function formatParams(
  params: { [key: string]: any },
  orderedKeys: string[] = []
): URLSearchParams {
  const url = new URLSearchParams();

  // Add ordered keys first
  orderedKeys.forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== '') {
      url.set(key, String(value));
    }
  });

  // Add remaining keys
  Object.entries(params).forEach(([key, value]) => {
    if (orderedKeys.includes(key)) return;
    if (value !== undefined && value !== null && value !== '') {
      url.set(key, String(value));
    }
  });

  return url;
}
